/**
 * WhatsApp Chat Support Widget
 * BEM naming convention: custom-whatsapp-section
 */

function initWhatsAppWidget(sectionId, whatsappNumber, showNotification, notificationDelay) {
  // DOM Elements with section-specific IDs
  const whatsappButton = document.getElementById(`whatsappButton-${sectionId}`);
  const notificationBubble = document.getElementById(`notificationBubble-${sectionId}`);
  const notificationBadge = document.getElementById(`notificationBadge-${sectionId}`);
  const closeNotification = document.getElementById(`closeNotification-${sectionId}`);
  const chatBox = document.getElementById(`chatBox-${sectionId}`);
  const closeChat = document.getElementById(`closeChat-${sectionId}`);
  const contactSupportBtn = document.getElementById(`contactSupportBtn-${sectionId}`);
  const inputModal = document.getElementById(`inputModal-${sectionId}`);
  const closeModal = document.getElementById(`closeModal-${sectionId}`);
  const sendWhatsAppBtn = document.getElementById(`sendWhatsAppBtn-${sectionId}`);
  const userMessage = document.getElementById(`userMessage-${sectionId}`);

  // State
  let notificationClosed = false;

  // localStorage keys
  const STORAGE_KEY_BUBBLE = 'whatsapp_bubble_interacted';
  const STORAGE_KEY_BADGE = 'whatsapp_messages_seen';

  // Check localStorage state
  const bubbleInteracted = localStorage.getItem(STORAGE_KEY_BUBBLE);
  const messagesSeen = localStorage.getItem(STORAGE_KEY_BADGE);

  // Hide badge if user has seen messages
  if (messagesSeen && notificationBadge) {
    notificationBadge.classList.add('custom-whatsapp-section__badge--hidden');
  }

  // Check if we're on the homepage
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';

  // Show notification bubble ONLY on homepage AND if user hasn't interacted yet
  if (showNotification && notificationBubble && isHomePage && !bubbleInteracted) {
    setTimeout(() => {
      if (!notificationClosed) {
        notificationBubble.classList.add('custom-whatsapp-section__notification-bubble--show');
      }
    }, notificationDelay);
  }

  // WhatsApp button click handler
  if (whatsappButton) {
    whatsappButton.addEventListener('click', () => {
      // Mark bubble as interacted
      localStorage.setItem(STORAGE_KEY_BUBBLE, 'true');

      // Hide notification bubble
      if (notificationBubble) {
        notificationBubble.classList.remove('custom-whatsapp-section__notification-bubble--show');
        notificationClosed = true;
      }

      // Hide badge and mark messages as seen when opening chat
      if (notificationBadge) {
        notificationBadge.classList.add('custom-whatsapp-section__badge--hidden');
      }

      // Toggle chat box
      if (chatBox) {
        if (chatBox.classList.contains('custom-whatsapp-section__chat-box--show')) {
          chatBox.classList.remove('custom-whatsapp-section__chat-box--show');
        } else {
          chatBox.classList.add('custom-whatsapp-section__chat-box--show');
          // Mark messages as seen when chat box opens
          localStorage.setItem(STORAGE_KEY_BADGE, 'true');
        }
      }
    });
  }

  // Close notification bubble
  if (closeNotification) {
    closeNotification.addEventListener('click', (e) => {
      e.stopPropagation();
      // Mark bubble as interacted when closed
      localStorage.setItem(STORAGE_KEY_BUBBLE, 'true');

      if (notificationBubble) {
        notificationBubble.classList.remove('custom-whatsapp-section__notification-bubble--show');
        notificationClosed = true;
      }
    });
  }

  // Close chat box
  if (closeChat) {
    closeChat.addEventListener('click', () => {
      if (chatBox) {
        chatBox.classList.remove('custom-whatsapp-section__chat-box--show');
      }
    });
  }

  // Contact Support button handler
  if (contactSupportBtn) {
    contactSupportBtn.addEventListener('click', () => {
      if (chatBox) {
        chatBox.classList.remove('custom-whatsapp-section__chat-box--show');
      }
      if (inputModal) {
        inputModal.classList.add('custom-whatsapp-section__input-modal--show');
      }
    });
  }

  // Close modal
  if (closeModal) {
    closeModal.addEventListener('click', () => {
      if (inputModal) {
        inputModal.classList.remove('custom-whatsapp-section__input-modal--show');
      }
    });
  }

  // Close modal when clicking outside
  if (inputModal) {
    inputModal.addEventListener('click', (e) => {
      if (e.target === inputModal) {
        inputModal.classList.remove('custom-whatsapp-section__input-modal--show');
      }
    });
  }

  // Send to WhatsApp
  if (sendWhatsAppBtn) {
    sendWhatsAppBtn.addEventListener('click', () => {
      const message = userMessage.value.trim();

      if (message === '') {
        alert('Please enter a message before sending.');
        return;
      }

      // Clean WhatsApp number (remove any non-numeric characters)
      const cleanNumber = whatsappNumber.replace(/\D/g, '');

      // Create WhatsApp URL
      const whatsappURL = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;

      // Open WhatsApp in new tab
      window.open(whatsappURL, '_blank');

      // Close modal and reset
      if (inputModal) {
        inputModal.classList.remove('custom-whatsapp-section__input-modal--show');
      }
      if (userMessage) {
        userMessage.value = '';
      }
    });
  }

  // Close elements when clicking outside
  document.addEventListener('click', (e) => {
    const widget = document.querySelector(`[data-section-id="${sectionId}"]`);

    if (widget && !widget.contains(e.target)) {
      if (chatBox) {
        chatBox.classList.remove('custom-whatsapp-section__chat-box--show');
      }
      if (notificationClosed && notificationBubble) {
        notificationBubble.classList.remove('custom-whatsapp-section__notification-bubble--show');
      }
    }
  });

  // Prevent clicks inside chat box from closing it
  if (chatBox) {
    chatBox.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // Prevent clicks inside notification from closing it
  if (notificationBubble) {
    notificationBubble.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // Handle Enter key in textarea (Shift+Enter for new line, Enter to send)
  if (userMessage) {
    userMessage.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (sendWhatsAppBtn) {
          sendWhatsAppBtn.click();
        }
      }
    });
  }
}

// Make function globally available
window.initWhatsAppWidget = initWhatsAppWidget;
